export { FFG, PRICE_DECIMALS, USDC_DECIMALS } from "@breakout/shared/constants"

import { BINARY_OUTCOME_LABELS } from "@breakout/shared/constants"

export const BUCKET_LABELS_5 = ["Top 5", "Top 10", "11-20", "21-50", "51+"] as const

export const BUCKET_DIRECTIONS_5: readonly ("up" | "down" | "neutral")[] = [
	"up",
	"up",
	"neutral",
	"down",
	"down",
]

export const BINARY_LABELS = BINARY_OUTCOME_LABELS

export const OUTCOME_DEFS_5 = [
	{ label: "Top 5", direction: "up" as const, minRank: 1, maxRank: 5 },
	{ label: "Top 10", direction: "up" as const, minRank: 6, maxRank: 10 },
	{ label: "11-20", direction: "neutral" as const, minRank: 11, maxRank: 20 },
	{ label: "21-50", direction: "down" as const, minRank: 21, maxRank: 50 },
	{ label: "51+", direction: "down" as const, minRank: 51, maxRank: null },
] as const

export const OUTCOME_DEFS_BINARY = [
	{ label: BINARY_LABELS[0], direction: "up" as const, minRank: 0, maxRank: null },
	{ label: BINARY_LABELS[1], direction: "down" as const, minRank: 0, maxRank: null },
] as const

export function getOutcomeLabel(
	bucketIndex: number,
	outcomeLabels?: string[] | null,
	isBinary = true,
): string {
	// If custom labels are provided, use them
	if (outcomeLabels && outcomeLabels.length > 0 && outcomeLabels[bucketIndex]) {
		return outcomeLabels[bucketIndex]
	}

	// For binary markets, use Long/Short
	if (isBinary) {
		return bucketIndex === 0 ? BINARY_LABELS[0] : BINARY_LABELS[1]
	}

	// For 5-bucket markets
	return BUCKET_LABELS_5[bucketIndex] ?? `Bucket ${bucketIndex}`
}

export function getOutcomeDirection(
	bucketIndex: number,
	isBinary = true,
): "up" | "down" | "neutral" {
	if (isBinary) {
		return bucketIndex === 0 ? "up" : "down"
	}
	return BUCKET_DIRECTIONS_5[bucketIndex] ?? "neutral"
}
